import { Modal } from "app-principal-componentes-visuales";
import React, { useState, useEffect, useContext } from "react";
import { AsistenciaMedicaContext } from "../../contexts/AsistenciaMedicaContext";
import { Direccion } from "../../interfaces/direccion.interface";
import { AsistenciaMedicaActionType } from "../../interfaces/global-state/asistencia.medica.action.type.enum";
import { SELECCIONAR_DOMICILIO, SINTOMAS } from "../../utils/constants";
import { eliminarLocalidadStorage } from "../../utils/ubicacionUtils";
import ErrorPage from "../ErrorPage/ErrorPage";
import "./SeleccionarDomicilio.scss";
import Direcciones from "../Direcciones/Direcciones";
import { checkearGeolocalizacion } from "../../helpers/googleApi";
import ProximidadUbicacion from "../../components/Modals/ProximidadUbicacion/ProximidadUbicacion";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import ReintentarPage from "../../components/ReintentarPage/ReintentarPage";
import SintomasSkeleton from "../../components/Skeletons/SintomasSkeleton/SintomasSkeleton";
import { loadProvincias } from "../../contexts/actions/actions";
import { useDirecciones } from "../../hooks/useDirecciones";

const SeleccionarDomicilio = ({ history }) => {

	const { useRequest, asistenciaMedica, dispatchAsistenciaMedica, storageManager, isWeb } = useContext(AsistenciaMedicaContext);
	const socioPrincipal = asistenciaMedica.usuario;
    const statusModulos = asistenciaMedica.statusModulos;
	const direccionesSocio = socioPrincipal.direcciones;
	const selectedDirection = asistenciaMedica.direccionSeleccionada
	const [error, setError] = useState(false)
	const [localidadError, setLocalidadError] = useState(false);
	const [proximidadModal, setProximidadModal] = useState(false);
	const [menorDireccionProxima, setMenorDireccionProxima] = useState(null);
	const [provinceError, setProvinceError] = useState(false)
	const [loadingProvinces, setLoadingProvinces] = useState(false)
	const { apiRequest } = useRequest();
	const { updateDirection, foundSelected } = useDirecciones({ socioPrincipal, apiRequest, direccionesSocio });

	useEffect(() => {
		dispatchAsistenciaMedica({
            type: AsistenciaMedicaActionType.actualizarDireccionSeleccionada,
            direccionSeleccionada: foundSelected(socioPrincipal.direcciones)
        })
	}, [socioPrincipal.direcciones]);

	useEffect( () => {
		if((!asistenciaMedica.provincias || asistenciaMedica.provincias.length === 0) && provinceError === false){
			setLoadingProvinces(true)
			setProvinceError(false)
			loadProvincias(apiRequest, dispatchAsistenciaMedica, setProvinceError, setLoadingProvinces)
		}
	}, [asistenciaMedica.provincias, provinceError])

	const handleClickValidarProximidad = (selectedOption) => {
        if(!statusModulos?.deshabilitarGeolocalizacionExacta) {
			checkearGeolocalizacion(direccionesSocio, selectedOption, asistenciaMedica?.geolocalizacion)
				.then(resultado => {
					if (resultado) {
						setMenorDireccionProxima(resultado);
						setProximidadModal(true);
					} else {
						handleClick(selectedOption);
					}
				})
				.catch(() => handleClick(selectedOption))
		} else {
			handleClick(selectedOption);
		}
	}

	/**
	 * actualiza la direccion seleccionada por proximidad
	 */
	const handleClickCambiarDireccionProximidad = () => {
		let direccionesAux: Direccion[] = direccionesSocio;
		direccionesAux.forEach(direccion => {
			direccion.seleccionado = (direccion.id === menorDireccionProxima.id)
		});
		const foundAddress = direccionesAux.find((address) => address.seleccionado === true);
		dispatchAsistenciaMedica({
			type: AsistenciaMedicaActionType.actualizarDireccion,
			direcciones: direccionesAux
		})
		updateDirection(direccionesAux);
		handleClick(foundAddress);
	}

	const handleClick = (foundAddress = null) => {
		let dirSeleccionada = foundAddress ? foundAddress : selectedDirection;
		if (selectedDirection.provincia === 'BUENOS AIRES' && (selectedDirection.localidad === 'CIUDAD AUTONOMA BUENOS AIRES' || selectedDirection.localidad === 'CAPITAL FEDERAL')) {
			if (!localidadError) {
				eliminarLocalidadStorage(storageManager);
				setLocalidadError(true);
			}
		} else {
			dispatchAsistenciaMedica({
				type: AsistenciaMedicaActionType.actualizarSintomas,
				sintomas: []
			})

			dispatchAsistenciaMedica({
				type: AsistenciaMedicaActionType.actualizarDireccionSeleccionada,
				direccionSeleccionada: dirSeleccionada
			})
			history.replace(SINTOMAS);
		}
	}

	if(loadingProvinces){
		return (
			<PageWrapper 
				socio={asistenciaMedica.usuario} 
				pageClassName="asistencia-seleccionar-domicilio"
				path={SELECCIONAR_DOMICILIO}
				className="verificar-datos-grid"
				>
				<SintomasSkeleton />
			</PageWrapper>)
	}

	if (error) {
		return <ErrorPage setError={setError} />
	}

	if(provinceError){
		return (
			<PageWrapper 
				socio={asistenciaMedica.usuario} 
				pageClassName="asistencia-seleccionar-domicilio"
				path={SELECCIONAR_DOMICILIO} className="reintentar-page" 
				>
				<ReintentarPage onClick={ () => { setProvinceError(false)} } />
			</PageWrapper>
		)
	}

	return (
		<>
				<Direcciones
					handleContinueClick={handleClickValidarProximidad}
					updateDirection={updateDirection}
					history={history}
					localidadError={localidadError}
					redirectTo={SINTOMAS}
					fromState={SELECCIONAR_DOMICILIO}
				/>

				<Modal
					screen60
					className="modal_web"
					component={
						<ProximidadUbicacion
							onClickContinuar={handleClick}
							onClickCambiarDireccion={handleClickCambiarDireccionProximidad}
							direccionMasProxima={menorDireccionProxima}
						/>
					}
					setShowModal={setProximidadModal}
					showModal={proximidadModal}
					id="modal-proximidad-ubicacion"
				/>
			</>
	)

};

export default SeleccionarDomicilio;